<div class="root">
    <div *ngFor="let item of options"
         (click)="onElementClicked(item)"
         [ngClass]="{active: selected == item}">
        {{itemPrefix}} {{item}}
    </div>
</div>
